var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 16,
    width: 56,
    height: 56,
    rx: 8,
    fill: "#F2994A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33309 62.6667V48.6667C9.33309 43.716 11.2998 38.968 14.8004 35.4674C18.3011 31.9667 23.049 30 27.9998 30C32.9505 30 37.6984 31.9667 41.1991 35.4674C44.6998 38.968 46.6664 43.716 46.6664 48.6667V62.6667H48.9998V67.3334H6.99976V62.6667H9.33309ZM13.9998 48.6667H18.6664C18.6664 46.1913 19.6498 43.8174 21.4001 42.067C23.1504 40.3167 25.5244 39.3334 27.9998 39.3334V34.6667C24.2867 34.6667 20.7258 36.1417 18.1003 38.7672C15.4748 41.3927 13.9998 44.9537 13.9998 48.6667V48.6667ZM25.6664 20.6667H30.3331V27.6667H25.6664V20.6667ZM46.1484 27.2187L49.4478 30.518L44.5011 35.467L41.1994 32.1677L46.1484 27.2187ZM6.55176 30.518L9.85109 27.2187L14.8001 32.1654L11.5031 35.4694L6.55176 30.518Z",
    fill: "#F2994A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarm);
export default __webpack_public_path__ + "static/media/Icon_Alarm.8acb5da0099fd457746dd5ffd278173f.svg";
export { ForwardRef as ReactComponent };